import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import CommandSearch from './CommandSearch';
import { Toaster } from '../ui/sonner';

export function Layout() {
  return (
    <div className="min-h-screen bg-bg-default">
      <Sidebar />
      
      {/* Main Content */}
      <main className="ml-64 min-h-screen">
        {/* Top Bar */}
        <header className="sticky top-0 z-10 bg-bg-default/80 backdrop-blur-md border-b border-border-default">
          <div className="flex items-center justify-between px-6 py-3">
            <div className="flex-1" />
            <CommandSearch />
          </div>
        </header>

        {/* Page Content */}
        <div className="p-6">
          <Outlet />
        </div>
      </main>

      <Toaster richColors position="top-right" />
    </div>
  );
}

export default Layout;
